<template>
  <b-container>
    <b-form
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="新しいパスワード"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              required
              placeholder="6文字以上入力してください"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="新しいパスワード（確認）"
            label-for="new-password"
          >
            <b-form-input
              id="new-password"
              v-model="form.passwordConfirmation"
              type="password"
              required
              placeholder="もう一度入力してください"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="submit"
              block
              variant="primary"
            >
              <b-icon
                v-if="userProfileStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>
                更新
              </span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {RESET_PASSWORD, SET_NOTIFICATION} from "@/store/constant";

export default {
  name: 'ResetPassword',
  data() {
    return {
      form: {
        password: '',
        passwordConfirmation: '',
        code: this.$route.query.code,
      },
    }
  },
  computed: {
    ...mapGetters(['userProfileStatus'])
  },
  methods: {
    onSubmit() {
      const { password, passwordConfirmation } = this.form;
      this.$store.commit(SET_NOTIFICATION,{ type: null });
      if (password !== passwordConfirmation) {
        this.$store.commit(SET_NOTIFICATION,{ type: 'error', messages: ['パスワードは一致していません'] });
        return;
      }
      this.$store.dispatch(RESET_PASSWORD, this.form)
        .then(() => {
          this.$router.push('/login');
        })
    },
  }
}
</script>
